module.exports = __webpack_public_path__ + "static/media/gooseNeckVine.3721d72c.jpg";